import { css, keyframes } from 'styled-components';

const rotate1 = keyframes`
	0% { transform: rotate(0deg); }
	12% { transform: rotate(90deg); }
	50% { transform: rotate(90deg); }
	62% { transform: rotate(180deg); }
	100% { transform: rotate(180deg); }
`;

const rotate2 = keyframes`
	0% { transform: rotate(0deg); }
	22% { transform: rotate(90deg); }
	50% { transform: rotate(90deg); }
	72% { transform: rotate(180deg); }
	100% { transform: rotate(180deg); }
`;

const rotate3 = keyframes`
	0% { transform: rotate(0deg); }
	32% { transform: rotate(90deg); }
	50% { transform: rotate(90deg); }
	82% { transform: rotate(180deg); }
	100% { transform: rotate(180deg); }
`;

const rotate4 = keyframes`
	0% { transform: rotate(0deg); }
	42% { transform: rotate(90deg); }
	50% { transform: rotate(90deg); }
	92% { transform: rotate(180deg); }
	100% { transform: rotate(180deg); }
`;

export const loaderAnimationStyles = css`
	.box {
		animation-duration: 2s;
		animation-timing-function: cubic-bezier(0.833, 0, 0.167, 1);
		animation-iteration-count: infinite;
		animation-fill-mode: both;
		transform-box: fill-box;
		transform-origin: center center;
		will-change: transform;
		transform: rotate(0deg);
	}

	.box-1 {
		animation-name: ${rotate1};
	}
	.box-2 {
		animation-name: ${rotate2};
	}
	.box-3 {
		animation-name: ${rotate3};
	}
	.box-4 {
		animation-name: ${rotate4};
	}
`;
